import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { TEditProjectDetailsReduxParams } from '~types/feat/project';
import ProjectGateway from '~apis/project';

export default function* watchEditProjectDetails(api: ProjectGateway): SagaWatcherReturnType {
    yield takeEvery('project/projectEditProjectDetailsAttempt', handleEditProjectDetails, api);
}

function* handleEditProjectDetails(api: ProjectGateway, action: PayloadAction<TEditProjectDetailsReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    if (!action.payload || Object.keys(action.payload).length === 0) {
        yield put(combinedActions.projectEditProjectDetailsFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        toast.error(ErrorMessages.GenericRequiredFieldNotFilledIn);
        return;
    }

    const apiPayload = {
        authToken,
        ...action.payload,
    };

    const response = yield* call([api, api.editProjectDetails], apiPayload);

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.projectEditProjectDetailsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.projectGetProjectListingAttempt());
        yield put(combinedActions.projectEditProjectDetailsSuccess());
        yield put(combinedActions.projectSetProjectDetailsModalIsEditing(false));
        yield put(combinedActions.projectSetProjectDetailsModalIsOpen(false));

        toast.success(SuccessMessages.ProjectEditProjectDetailsSuccess);
    }
}
